import { render } from "./ValidationSummary.vue?vue&type=template&id=45d3ffc6&scoped=true&ts=true"
import script from "./ValidationSummary.vue?vue&type=script&lang=ts"
export * from "./ValidationSummary.vue?vue&type=script&lang=ts"

import "./ValidationSummary.vue?vue&type=style&index=0&id=45d3ffc6&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d3ffc6"]])

export default __exports__